import { render } from "./LoopView.vue?vue&type=template&id=c5ed5930"
import script from "./LoopView.vue?vue&type=script&lang=js"
export * from "./LoopView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__